<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-checkbox ttLabel="valid_for_all_stockplace" [(ttModel)]="edit.valid_for_all_stockplace"></tt-checkbox>

        <div [hidden]="edit.valid_for_all_stockplace === '1'">
            <tt-select ttLabel="businessco" [(ttModel)]="edit.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
            <tt-select ttLabel="stockplace" [(ttModel)]="edit.stockplace_id" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>
        </div>

        <tt-button-save ttText="freightratesetcreate_create" (ttClick)="createChanges()" [ttLoading]="creating"></tt-button-save>
    </tt-card>
</tt-page>
